/**
 * Alatreyu — Real User Monitoring (Web Vitals → GA4)
 *
 * Loads Google's web-vitals library from CDN and reports each Core Web Vital
 * (LCP, CLS, INP, TTFB, FCP) to GA4 via the existing dataLayer.
 *
 * GA4 custom event: "web_vitals"
 *   - metric_name: string  (LCP | CLS | INP | TTFB | FCP)
 *   - metric_value: number (milliseconds or unitless for CLS)
 *   - metric_rating: string (good | needs-improvement | poor)
 *   - metric_id: string    (unique per page-load, for dedup)
 */
(function () {
  'use strict';

  function sendToGA4(metric) {
    if (typeof gtag !== 'function') return;

    gtag('event', 'web_vitals', {
      metric_name: metric.name,
      metric_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      metric_rating: metric.rating,
      metric_id: metric.id
    });
  }

  // Load web-vitals v4 from CDN (attribution build, ~2KB gzip)
  var script = document.createElement('script');
  script.src = 'https://unpkg.com/web-vitals@4/dist/web-vitals.iife.js';
  script.async = true;
  script.onload = function () {
    if (!window.webVitals) return;
    window.webVitals.onLCP(sendToGA4);
    window.webVitals.onCLS(sendToGA4);
    window.webVitals.onINP(sendToGA4);
    window.webVitals.onTTFB(sendToGA4);
    window.webVitals.onFCP(sendToGA4);
  };
  document.head.appendChild(script);
})();
